import {
  TRACE,
  MICROSTRIP,
  EYE_MASK,
  CPHY_EYE_MASK,
} from "../../../constants/libraryConstants";
import { CPHY } from "../../PCBHelper/constants";
import { getDefaultTreeItems } from "../helper/andesTree";
import libraryConstructor from './libraryConstructor';
import { getLibraryArray } from "./libraryTree";


function getIBISModelList(libraryModels = {}, model, serdesType) {
  const models = libraryModels.models || [];
  const packages = libraryModels.packages || [];
  const selectorModels = libraryModels.selectorModels || [];

  if (serdesType === CPHY) {
    const pinsGroup = packages.map(item => item.pinSection)
    return getCPHYIBISModelList(pinsGroup)
  }
  /*  component: "HDMI_TX"
      generic:[]
      packageModel: ""
      pinSection: [
        {
      model_name: "HDMI_TX"
      pin: "1"
      signal_name: "PADP"
        }] */
  let pinModelList = [];
  for (let pkgItem of packages) {

    for (let pinItem of pkgItem.diffPins) {
      const findPin = pkgItem.pinSection.find(it => it.pin === pinItem.pin);
      const findInvPin = pkgItem.pinSection.find(it => it.pin === pinItem.invPin);

      const pinModels = getModelsByPin({
        models,
        selectorModels,
        pinInfo: findPin
      });
      const invPinModels = getModelsByPin({
        models,
        selectorModels,
        pinInfo: findInvPin
      });
      if (!pinModels.length || !invPinModels.length) {
        continue;
      }

      let pinModel = pinModels[0].name, invPinModel = invPinModels[0].name;
      if (model && model.pin === findPin.pin) {
        pinModel = model.modelName;
      }

      if (model && model.invPin === findInvPin.pin) {
        invPinModel = model.invModelName;
      }

      pinModelList.push({
        pin: { ...findPin },
        invPin: { ...findInvPin },
        pinModels,
        invPinModels,
        pinModel,
        invPinModel
      })
    }
  }
  return pinModelList;
}

function getCPHYIBISModelList(pinsGroup) {

  const modelGroup = []
  for (const pins of pinsGroup) {
    const signalNames = { A: [], B: [], C: [] }, pinInfoAMap = new Map(), pinInfoBMap = new Map(), pinInfoCMap = new Map();
    // pinInfo : {signal_name,model_name}/{signalName,modelName}
    for (const pinInfo of pins) {
      const signalName = pinInfo.signal_name || pinInfo.signalName || "";
      const modelName = pinInfo.model_name || pinInfo.modelName || "";
      const _pinInfo = { ...pinInfo, signal_name: signalName, model_name: modelName };
      if (signalName.match(/_A\d_/)) {
        pinInfoAMap.set(signalName, _pinInfo)
        signalNames.A.push(signalName)
      } else if (signalName.match(/_B\d_/)) {
        pinInfoBMap.set(signalName, _pinInfo)
        signalNames.B.push(signalName)
      } else if (signalName.match(/_C\d_/)) {
        pinInfoCMap.set(signalName, _pinInfo)
        signalNames.C.push(signalName)
      }
    }

    for (const [key, value] of pinInfoAMap) {
      // _A0_ prefix
      const prefix = key.split(/_A\d_/)[0];
      // cut _A0_
      const index = key.match(/_A\d/)[0].replace(/_A/, '');

      const BPinName = signalNames.B.find(name => name.split(`_B${index}_`)[0] === prefix);
      const CPinName = signalNames.C.find(name => name.split(`_C${index}_`)[0] === prefix);
      const BInfo = pinInfoBMap.get(BPinName);
      const CInfo = pinInfoCMap.get(CPinName);
      if (value && BInfo && CInfo) {
        modelGroup.push({ AInfo: value, BInfo, CInfo })
      }
    }

    return modelGroup;
  }
}

function getModelsByPin({
  models,
  selectorModels,
  pinInfo
}) {
  let pinModels = JSON.parse(JSON.stringify(models.filter(item => item.name === pinInfo.model_name)));
  if (!pinModels.length) {
    const selectors = selectorModels.filter(item => item.selector === pinInfo.model_name);
    for (let sec of selectors) {
      pinModels.push(...JSON.parse(JSON.stringify(sec.models)));
    }
  }
  return pinModels;
}

function getIbisAmiFileList(ibsInfo, fileNames = []) {
  if (!ibsInfo.ibisAmi || !ibsInfo.ibisAmi.amis || !ibsInfo.ibisAmi.amis.length) {
    return []
  }
  return ibsInfo.ibisAmi.amis.map(item => { return { fileName: item.name } }).filter(item => !fileNames.includes(item.fileName));
}

function getPanelLibraryList() {
  const defaultTreeItems = getDefaultTreeItems();
  const libraryList = defaultTreeItems[0].children.map(item => {
    if (item.children.length > 0) {
      return { name: item.name, key: item.key, children: item.children.map(it => ({ name: it.name, key: it.key })) }
    }

    return { name: item.name, key: item.key }
  })

  console.log(libraryList);


  const newList = libraryList.map(info => {
    if (info.children) {
      return {
        ...info,
        children: info.children.map(it => {
          const item = libraryConstructor.getLibraryValues(it.key);
          return {
            ...it,
            children: item.length ? getLibraryArray(item[0].type, item) : []
          }
        }).filter(d => d.children.length)
      }
    }

    const item = info.key === EYE_MASK
      ? [...libraryConstructor.getLibraryValues(EYE_MASK), ...libraryConstructor.getLibraryValues(CPHY_EYE_MASK)]
      : libraryConstructor.getLibraryValues(info.key);
    return {
      ...info,
      children: !item.length ? []
        : info.key === TRACE ? getLibraryArray(item[0].type, item).map((it) => ({ ...it, name: `${it.name} - ${it.type === MICROSTRIP ? 'Microstrip' : 'Stripline'}` }))
          : getLibraryArray(item[0].type, item)
    }
  }).filter(d => d.children.length);

  const addKey = (arr) => arr.map(item => ({
    ...item,
    title: item.name,
    showTitle: item.name,
    value: item.children ? item.key : item.id,
    isDownload: item.children ? false : true,
    children: item.children ? addKey(item.children) : null
  }))
  let _newList = addKey(newList);

  // check file
  if (_newList[0].children.length) {
    let res = {
      title: 'All',
      value: 'All',
      key: 'All',
      typeName: "Library",
      isDownload: false,
      children: _newList,
    };
    return [res];
  } else {
    return [];
  }
}

function deleteFolderChild(children, deleteId, pathIds) {
  const targetIndex = children.findIndex(item => item.id === deleteId);
  if (targetIndex > -1) {
    return children.filter(item => item.id !== deleteId);
  } else {
    const newChildren = children;
    const childrenIndex = children.findIndex(item => pathIds.includes(item.id));
    if (childrenIndex > -1) {
      newChildren[childrenIndex].children = deleteFolderChild(children[childrenIndex].children, deleteId, pathIds);
      return newChildren;
    } else {
      return children;
    }
  }
}

export {
  getIBISModelList,
  getIbisAmiFileList,
  getPanelLibraryList,
  getCPHYIBISModelList,
  deleteFolderChild
}